import React from 'react';

import { FormContainer } from '@eika-kortbetjening/form-container';
import { SummaryCard } from '@eika/card';
import { RichIconTypes } from '@eika/rich-icon';

import ErrorDisplay from './error-display/ErrorDisplay';
import fallbackDictionary from './fallbackDictionary';
import Footer from './footer/Footer';
import SuccessReceipt from './success-receipt/SuccessReceipt';
import { Piwik, SiteCoreDictionary, SoftBlockLoader } from './types';

import './BlockFormConfirmSoftBlock.scss';

interface BlockFormConfirmSoftBlockProps {
    /** Formatted card number of selected card */
    formattedCardNumber: string;
    /** Formatted account number of selected card */
    formattedAccountNumber: string;
    formattedPhoneNumber?: string;
    /** Function to request a soft block of selected card */
    submit: () => void;
    /** Function for the cancel button */
    cancel: () => void;
    /** Soft block loader object */
    softBlockLoader: SoftBlockLoader;
    /** Sitecore dictionary */
    sitecoreDictionary?: SiteCoreDictionary;
    /** PIWIK tags */
    piwik?: Piwik;
}

const BlockFormConfirmSoftBlock = ({
    formattedCardNumber,
    formattedAccountNumber,
    submit,
    formattedPhoneNumber,
    cancel,
    softBlockLoader,
    sitecoreDictionary,
    piwik,
}: BlockFormConfirmSoftBlockProps) => {
    const dictionary: SiteCoreDictionary = { ...fallbackDictionary, ...sitecoreDictionary };
    const { isSoftBlockingCard, hasSoftBlockedCard } = softBlockLoader;
    const { softBlockConfirm, softBlockConfirmInformation, blockConfirmToAccountNumber } = dictionary;

    const showReceipt = hasSoftBlockedCard;

    return (
        <FormContainer
            data-track-id={piwik?.blockCardForm?.softBlockCardConfirmForm?.dataTrackId}
            data-track-linkname={piwik?.blockCardForm?.softBlockCardConfirmForm?.dataTrackLinkname}
            id={piwik?.blockCardForm?.softBlockCardConfirmForm?.dataTrackId}
        >
            <FormContainer.Content>
                {showReceipt ? (
                    <SuccessReceipt softBlockLoader={softBlockLoader} dictionary={dictionary} piwik={piwik} />
                ) : (
                    <>
                        <div className="soft-block-summary-content-container">
                            <SummaryCard
                                className="soft-block-summary-info-card"
                                icon={RichIconTypes.REGNING_M_KAFFEKOPP}
                            >
                                <section className="soft-block-summary-section">
                                    <p className="soft-block-card-title">{softBlockConfirm}</p>
                                    <p className="soft-block-card-information">{`${softBlockConfirmInformation} ${formattedCardNumber} (${blockConfirmToAccountNumber} ${formattedAccountNumber}).`}</p>
                                    {formattedPhoneNumber ? (
                                        <p>
                                            {dictionary.confirmBySmsText}: <strong>{formattedPhoneNumber}</strong>.
                                        </p>
                                    ) : null}
                                </section>
                            </SummaryCard>
                        </div>
                        <ErrorDisplay softBlockLoader={softBlockLoader} dictionary={dictionary} piwik={piwik} />
                    </>
                )}
            </FormContainer.Content>
            <FormContainer.Footer>
                <Footer
                    submit={submit}
                    cancel={cancel}
                    loading={isSoftBlockingCard}
                    showReceipt={showReceipt}
                    dictionary={dictionary}
                    piwik={piwik}
                />
            </FormContainer.Footer>
        </FormContainer>
    );
};

export default BlockFormConfirmSoftBlock;
